export const progressSpinnerTheme = {
  colorScheme: {
    light: {
      root: {
        colorOne: 'var(--p-primary-400)',
        colorTwo: 'var(--p-primary-500)',
        colorThree: 'var(--p-primary-600)',
        colorFour: 'var(--p-primary-700)',
      },
    },
    dark: {
      root: {
        colorOne: 'var(--p-primary-400)',
        colorTwo: 'var(--p-primary-500)',
        colorThree: 'var(--p-primary-600)',
        colorFour: 'var(--p-primary-700)',
      },
    },
  },
};
